export default __webpack_public_path__ + "static/media/ic_rus_lang.5ed20911.svg";